import React, { useState, useEffect } from 'react';
import Axios from "axios";
import ConsultantLayout from '../commonlayouts/consultantlayout';
import { Link, useNavigate } from 'react-router-dom';
import { SendMailToHotList } from '../apiconstants/constants';
import WYSIWYGEditor from "../helpers/WYSIWYGEditor";
import { useForm, Controller } from "react-hook-form";
import Swal from "sweetalert2";
import LoadingSpinner from "../helpers/loadingspinner";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const SelectedHotList = () => {
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const storedCandidates = JSON.parse(localStorage.getItem('SelectedSubVendorList') || '[]');
  const clientData = JSON.parse(localStorage.getItem("clientData"));
const token = localStorage.getItem("jwtToken");
  const [isLoading, setIsLoading] = useState(false);
const {  register,  reset,  handleSubmit,  control,  formState: { errors, isSubmitting },  getValues} = useForm(); 
 const navigate = useNavigate();
  const [isDisabled, setIsDisabled] = useState(false);
  const [showPreview, setShowPreview] = useState(false);  
  const [previewHtml, setPreviewHtml] = useState("");
    const email = localStorage.getItem("email")
        const mobileNumber = localStorage.getItem("mobileNumber");
         const guid = localStorage.getItem("guid");
const handlePreview = () => {
  if (!showPreview) {
    const { subject, content } = getValues();

    if (!subject || !content) {
      Swal.fire("Incomplete", "Please enter both Subject and Content to preview.", "info");
      return;
    }

    const html = `
      <div style="font-family: Arial, sans-serif; line-height: 1.6;">
        <div>${content}</div>
      </div>
    `;

    setPreviewHtml(html);
    setShowPreview(true);
  } else {
    setShowPreview(false);
  }
};

  useEffect(() => {
    if (storedCandidates) {
      setSelectedCandidates(storedCandidates);
    }
  }, []);

  const onSubmit = async (data, e) => {
    console.log(data);
    e.preventDefault();
    reset();
    setIsLoading(true);
    sendSelectedItemsToApi(data);
  }

  const sendSelectedItemsToApi = async (data) => {
    setIsLoading(true);
    const hotlist = selectedCandidates.map(candidate => ({
      name: candidate.name,
      email: candidate.emailId
    }));
    const params = {
      "content": data.content,
      "fromMail":email,
      "cCmail":"",
      "phonenumber":mobileNumber || "",
      "subject": data.subject,
      "leads": hotlist,
      "logoUrl": clientData?.logoURL,
      "companyName": clientData?.companyName,
      "guid" : guid
    };
    const apiUrl = SendMailToHotList.APIURL;
    try {
      const result = await Axios.post(apiUrl, params,
        { headers: {   
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        }
      }
      );
      setIsLoading(false);
      if (result.data === 'Emails sent successfully to all hot list') {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Sent Successfully',
          showConfirmButton: false,
          timer: 5000
        });
        navigate("/Employer/ListofStaffingContacts");
        localStorage.removeItem("SelectedSubVendorList")
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Add correct Details',
          showConfirmButton: false,
          timer: 5000
        });
      }
    } catch (error) {
      console.log("Error" + error);
      setIsLoading(false);
    }
  };

  return (
    <ConsultantLayout>
      {isLoading ? <center><LoadingSpinner /></center> :
        <div className='container-fluid mt-3'>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Link to="/Employer/ListofStaffingContacts">
              <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px', marginTop: 8 }} aria-hidden="true"></i>
            </Link>
            <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: 8 }}>Selected Staffing Contacts List</h2>
          </div>
          <table className="table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
              </tr>
            </thead>
            <tbody>
              {selectedCandidates.map(item => (
                <tr key={item.hotListID}>
                  <td>{item.name}</td>
                  <td>{item.emailId}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <form onSubmit={handleSubmit(onSubmit)} id="loginform">
            <div>
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Subject</Tooltip>)}>
                <input type="text" title='' placeholder='Subject' {...register("subject", { required: "Subject Required" })} id="subject" name="subject"
                  disabled={isDisabled} className={`form-control basic-form mt-3 ${errors.subject ? 'is-invalid' : ''}`}
                />
              </OverlayTrigger>
              <div className="invalid-feedback"> {errors.subject?.message}</div>
            </div>
            <div>
              <label style={{ color: "#00a7ac", marginTop: 10 }}>Content</label>
              <Controller
                control={control}
                name="content"
                rules={{
                  required: { value: true, message: "Content Required" },
                }}
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <div>
                    <WYSIWYGEditor
                      onChange={onChange}
                      onBlur={onBlur}
                      value={value}
                      ref={ref}
                      inputExtraProps={{
                        required: true,
                      }}
                    />
                    {errors.content && (
                      <p style={{ marginTop: '0.25em', fontSize: '80%', color: '#dc3545' }}>
                        {errors.content.message}
                      </p>
                    )}
                  </div>
                )}
              />
            </div>
          <div className="d-flex justify-content-end align-items-start gap-2 mt-5 flex-wrap">
  <button
    type="button"
    className="btn btn-primary"
    onClick={handlePreview}
  >
    {showPreview ? "Hide Preview" : "Preview Email"}
  </button>

  <button
    id="svbutton"
    disabled={isSubmitting || isDisabled}
    className="btn btn-primary pf-save"
  >
    Send Email
  </button>

  <Link to="/Employer/ListofStaffingContacts">
    <button className="btn btn-primary">
      Cancel
    </button>
  </Link>
</div>

          </form>
          {showPreview && (
  <div
    className="card p-3 mt-4"
    style={{ backgroundColor: "#f8f9fa", border: "1px solid #ced4da",fontSize:14 }}
  >
    <h5 style={{ color: "#00a7ac" }}>Email Preview</h5>
    Dear {selectedCandidates[0]?.name},
    <div dangerouslySetInnerHTML={{ __html: previewHtml }} />

<br/>
   <p>Best regards,<br />
    <strong>KnackHook Staffing Team,</strong><br />
 ✉️ {email || "staffing@knackhook.com"},<br/>
      📞 {mobileNumber || ""}.</p>
  </div>
)}
        </div>
      }
    </ConsultantLayout>
  );
}

export default SelectedHotList;
